import { Action } from "redux";
import { Country } from "../../../model/Country";

export const LIST_COUNTRIES_SUCCESS = "LIST_COUNTRIES_SUCCESS";

export interface ListCountriesSuccessAction extends Action {
  type: typeof LIST_COUNTRIES_SUCCESS;
  countries: Country[];
}

export const listCountriesSuccess = (
  countries: Country[]
): ListCountriesSuccessAction => ({
  type: LIST_COUNTRIES_SUCCESS,
  countries,
});
